module.exports = __webpack_public_path__ + "media/site_templates/www.hirecleaners.com.au/images/testimonials-3cdf40f911aa6127a426e9ed5c79d9de.jpg";